import { Component } from 'react';
import { Redirect } from 'react-router';
import { urls } from '../logic/urls';

export class Home extends Component<{}, {}> {
    render() {
        return <Redirect to={urls.search} />
    }
}